import React, { useEffect, useState } from 'react'

// Libs
import { motion, AnimatePresence } from 'framer-motion'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'
import Sticky from 'react-sticky-el'

// Settings
import * as routes from './../../settings/_routesSettings'

// Components
import {
  Typography,
  Button,
  useDimensions,
} from '@telavita-core/react-design-kit'
import Login from 'components/Login'

// Assets
import PlansMobile from 'static/images/plans-mobile.png'
import PlansDesktop from 'static/images/plans-desktop.png'
import { ReactComponent as IconClose } from 'static/svg/close.svg'

export const SignInBar = ({ handleLogin, failMessage }) => {
  const history = useHistory()
  const { isMobile } = useDimensions()

  const [showLogin, setShowLogin] = useState(false)
  const [alreadyClosed, setAlreadyClosed] = useState(false)

  const _alreadyClosedRef = React.useRef(alreadyClosed)

  const _setAlreadyClosed = (data) => {
    _alreadyClosedRef.current = data
    setAlreadyClosed(data)
  }

  const myScrollFunc = function() {
    var y = window.scrollY
    if (y >= 800) {
      if (!_alreadyClosedRef.current) setShowLogin(true)
    }
  }

  const handleCloseModal = () => {
    _setAlreadyClosed(true)
    setShowLogin(false)
  }

  useEffect(() => {
    window.addEventListener('scroll', myScrollFunc)
    return () => {
      window.removeEventListener('scroll', myScrollFunc)
    }
  }, [])

  const renderLoginData = () => {
    return (
      <div className='SignInBar__LoginData'>
        <Typography
          variant='content2'
          weight='bold'
          customClassName='SignInBar__LoginData__Label'
        >
          Para ver profissionais do seu plano de saúde ou empresa, entre ou crie uma conta:
        </Typography>
        <div className='SignInBar__ButtonsWrapper'>
          <Button
            variant='contained'
            customClassName='SignInBar__SignInButton'
            onClick={() => history.push(routes.LOGIN)}
          >
            ENTRAR
          </Button>
          <Button
            variant='outlined'
            customClassName='SignInBar__SignUpButton'
            onClick={() => history.push(routes.REGISTER)}
          >
            CRIAR CONTA
          </Button>
        </div>
      </div>
    )
  }

  return (
    <>
        <AnimatePresence>
          {showLogin && (
            <motion.div
              className='SignInBarBackdrop'
              initial={{ opacity: 0 }}
              animate={{ opacity: 20, transition: { duration: 0.5 } }}
              exit={{ opacity: 0 }}
            >
              <motion.div
                className='SignInBar__Expanded'
                key="modal"
                initial={{ y: 500, opacity: 0 }}
                animate={{ y: 0, opacity: 1, transition: { duration: 0.6 } }}
                exit={{ y: 500, opacity: 0 }}          
              >
            <>
              <button
                className='SignInBar__CloseButton'
                onClick={() => handleCloseModal()}
              >
                <IconClose />
              </button>
              <img 
                className='SignInBar__PlansImage'
                src={isMobile ? PlansMobile : PlansDesktop} 
                alt='Imagem exibindo os convenios atendidos pela Telavita Bradesco saúde, Care Plus, Omint, Sompo Saúde'
              />

              {isMobile ? (
                renderLoginData()
              ) : (
                <div className='SignInBar__LoginWrapper'>
                  <Login
                    handleLogin={handleLogin}
                    failMessage={failMessage}
                    title='Para ver profissionais do seu plano de saúde ou empresa, entre ou crie uma conta:'
                  />
                  <div className='SignInBar__LinkWrapper'>
                    <Typography variant='content2'>
                      <Link
                        to={routes.RECOVER_EMAIL}
                        className='SignInBar__Link'
                      >
                        Esqueceu seu e-mail?
                      </Link>
                    </Typography>
                    <Typography variant='content2'>
                      <Link
                        to={routes.FORGOT_PASSWORD}
                        className='SignInBar__Link'
                      >
                        Esqueceu a senha?
                      </Link>
                    </Typography>
                  </div>
                  <div className='SignInBar__DividerWrapper'>
                    <div className='SignInBar__DividerWrapper__Divider' />
                    <Typography variant='content2'>ou</Typography>
                    <div className='SignInBar__DividerWrapper__Divider' />
                  </div>
                  <Button
                    variant='outlined'
                    customClassName='SignInBar__SignUpButton__Expanded'
                    onClick={() => history.push(routes.REGISTER)}
                  >
                    CRIAR CONTA
                  </Button>
                  <Typography
                    variant='content2'
                    customClassName='SignInBar__Link'
                    onClick={() => handleCloseModal()}
                  >
                    Agora não
                  </Typography>
                </div>
              )}
            </>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
          {!showLogin && !isMobile && (
            <Sticky
              mode='bottom'
            >
              <div 
                className='SignInBar__Collapsed'
              >
                {renderLoginData()}
              </div>
            </Sticky>
          )}
    </>
  )
}
